<template>
  <div>
    <v-row class="diagnostico-header">
      <v-col>
        <v-row>
          <v-col md="10" sm="10" lg="10">
            <h4 v-if="perguntaObj.percentual && percentual < 100">
              <span v-if="perguntaObj.pergunta">
                {{ perguntaObj.percentual.municipio.nome }} -

                {{ perguntaObj.pergunta.pergunta.tema.nome }}
              </span>
            </h4>

            <h2 v-if="perguntaObj.pergunta">
              {{ perguntaObj.pergunta.pergunta.numero }} -
              {{ perguntaObj.pergunta.pergunta.texto }}
              <app-modal-show-evidence
                :dialog="showDialog"
                :evidence="perguntaObj.pergunta.pergunta.evidencia"
                color="warning"
                v-if="
                  perguntaObj.pergunta.pergunta.evidencia &&
                  perguntaObj.pergunta.pergunta.evidencia.trim()
                "
              >
              </app-modal-show-evidence>

              <p v-if="perguntaObj.pergunta.pergunta.pontos_especificos">
                <v-text-field
                  label="Pontos"
                  name="pontos"
                  type="text"
                  v-model="perguntaObj.pergunta.pontos_especificos"
                ></v-text-field>
              </p>
            </h2>
            <div
              v-if="
                perguntaObj.pergunta &&
                perguntaObj.pergunta.pergunta.possuiComentario
              "
            >
              <v-textarea
                label="Comentário"
                name="Comentário"
                type="text"
                :maxlength="1000"
                solo
                hide-details
                no-resize
                v-model="perguntaObj.pergunta.comentario"
              >
              </v-textarea>
              <div style="text-align: end">
                {{
                  perguntaObj.pergunta.comentario
                    ? perguntaObj.pergunta.comentario.length
                    : 0
                }}/1000 caracteres
              </div>
            </div>
          </v-col>

          <v-col md="2" sm="2" lg="2" class="text-right" align="center">
            <div v-if="percentual <= 100 && perguntaObj.pergunta">
              <p>
                <v-avatar :color="isAnswerTrue">
                  <v-icon
                    color="white"
                    @click="answerQuestion(true)"
                    title="Sim"
                  >
                    mdi-thumb-up-outline
                  </v-icon>
                </v-avatar>
              </p>

              <p class="mt-3">
                <v-avatar
                  :color="isAnswerFalse"
                  v-if="!perguntaObj.pergunta.pergunta.pontos_especificos"
                >
                  <v-icon
                    color="white"
                    @click="answerQuestion(false)"
                    title="Não"
                  >
                    mdi-thumb-down-outline
                  </v-icon>
                </v-avatar>
              </p>
            </div>

            <div v-if="percentual === 100 && !this.perguntaObj.pergunta">
              <v-btn color="accent" class="ml-3" @click="finishTheme()">
                FINALIZAR
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="!isSala" justify="center">
      <v-col justify="center" align="center" class="image-container">
        <v-img
          :src="require('@/assets/img/mapa/cidade-base.jpg')"
          class="image-base"
          v-bind:class="{
            'image-base': percentual < 100,
            'image-base-complete': percentual === 100,
          }"
        >
        </v-img>
        <span>
          <v-img
            :src="require('@/assets/img/mapa/AGR/AGR.png')"
            class="image-content"
          >
          </v-img>
        </span>
        <mapa-lideranca
          v-if="perguntaObj.percentual.tema.nome === 'Liderança'"
          :perguntaObj="perguntaObj"
        ></mapa-lideranca>

        <mapa-compras-publicas
          v-if="perguntaObj.percentual.tema.nome === 'Compras Públicas'"
          :perguntaObj="perguntaObj"
        ></mapa-compras-publicas>

        <mapa-desburocratizacao
          v-if="perguntaObj.percentual.tema.nome === 'Desburocratização'"
          :perguntaObj="perguntaObj"
        ></mapa-desburocratizacao>

        <mapa-desenvolvimento-economico
          v-if="
            perguntaObj.percentual.tema.nome === 'Desenvolvimento Econômico'
          "
          :perguntaObj="perguntaObj"
        ></mapa-desenvolvimento-economico>

        <mapa-educacao-empreendedora
          v-if="perguntaObj.percentual.tema.nome === 'Educação Empreendedora'"
          :perguntaObj="perguntaObj"
        ></mapa-educacao-empreendedora>

        <mapa-gestao-municipal
          v-if="perguntaObj.percentual.tema.nome === 'Gestão Municipal'"
          :perguntaObj="perguntaObj"
        ></mapa-gestao-municipal>

        <mapa-inovacao-e-sustentabilidade
          v-if="
            perguntaObj.percentual.tema.nome === 'Inovação e Sustentabilidade'
          "
          :perguntaObj="perguntaObj"
        ></mapa-inovacao-e-sustentabilidade>

        <mapa-sala-do-empreendedor
          v-if="perguntaObj.percentual.tema.nome === 'Sala Do Empreendedor'"
          :perguntaObj="perguntaObj"
        ></mapa-sala-do-empreendedor>
        <!--
        <mapa-novo
          :perguntaObj="perguntaObj"
        ></mapa-novo>
        -->
      </v-col>
    </v-row>
    <v-footer app color="primary" class="app-footer">
      <v-row style="margin-left: 70px">
        <v-col md="1" sm="1" lg="1">
          <v-btn
            color="accent"
            v-if="
              (perguntaObj.pergunta &&
                perguntaObj.pergunta.pergunta.perguntaAnteriorSim > 0) ||
              perguntaObj.percentual.ultimaPerguntaRespondida > 0
            "
            md="1"
            sm="1"
            lg="1"
            class="return-question"
            @click="returnQuestion()"
          >
            <v-icon justify="center" align="center" color="white">
              mdi-arrow-left-bold-outline
            </v-icon>
          </v-btn>
        </v-col>
        <v-col style="display: flex; align-items: center">
          <v-progress-linear :value="percentual" color="white" height="25">
            <strong>{{ percentual }} %</strong>
          </v-progress-linear>
        </v-col>

        <v-col md="2" sm="2" lg="2" class="text-right">
          <v-btn color="accent" class="ml-3" @click="openThemePage()">
            SALVAR E SAIR
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { diagnosticAPI } from "./DiagnosticAPI";
import { attendanceQuestionAPI } from "./AttendanceQuestionAPI";
import { mapActions, mapGetters } from "vuex";
import MapaLideranca from "./MapaLideranca";
import MapaComprasPublicas from "./MapaComprasPublicas";
import MapaDesburocratizacao from "./MapaDesburocratizacao";
import MapaDesenvolvimentoEconomico from "./MapaDesenvolvimentoEconomico";
import MapaEducacaoEmpreendedora from "./MapaEducacaoEmpreendedora";
import MapaGestaoMunicipal from "./MapaGestaoMunicipal";
import MapaInovacaoESustentabilidade from "./MapaInovacaoESustentabilidade";
import MapaSalaDoEmpreendedor from "./MapaSalaDoEmpreendedor";
// import MapaNovo from './MapaNovo'
import AppModalShowEvidence from "./ModalShowEvidence";
import { cityAPI } from "@/modules/city/API/CityAPI";
import {
  statusRelacionamentoEnum,
  statusContratoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";
import Swal from "sweetalert2";

export default {
  components: {
    MapaLideranca,
    MapaComprasPublicas,
    MapaDesburocratizacao,
    MapaDesenvolvimentoEconomico,
    MapaEducacaoEmpreendedora,
    MapaGestaoMunicipal,
    MapaInovacaoESustentabilidade,
    MapaSalaDoEmpreendedor,
    // MapaNovo,
    AppModalShowEvidence,
  },
  data() {
    return {
      showDialog: false,
      temaId: this.$route.params.idtema,
      acompanhamentoId: this.$route.params.id,
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      perguntaObj: {
        pergunta: {
          pergunta: {
            tema: {},
          },
        },
        percentual: {
          municipio: {},
          tema: {},
        },
      },
      percentual: 0,
      municipio: null,
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      statusContratoEnum: statusContratoEnum,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadQuestion() {
      this.setLoading(true);
      diagnosticAPI
        .getQuestion(
          this.temaId,
          this.acompanhamentoId,
          this.getMunicipioNaoVigenteRespondeSoPerguntasNacionais()
        )
        .then((resp) => {
          this.perguntaObj = resp.data;
          this.percentual = Math.ceil(
            (this.perguntaObj.percentual.perguntasRespondidas /
              this.perguntaObj.percentual.perguntasTema) *
              100
          );
          if (!this.perguntaObj.pergunta) this.percentual = 100;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },

    getMunicipioNaoVigenteRespondeSoPerguntasNacionais(municipio) {
      if (this.isFullAdmin) return false;

      if (
        this.config.municipiosNaoVigentesRespondemPerguntasNacionais &&
        this.groupsConfig.municipiosNaoVigentesRespondemPerguntasNacionais &&
        !this.getMunicipioVigente(municipio)
      ) {
        return true;
      }

      return false;
    },
    getMunicipioVigente() {
      let isVigente = true;

      return isVigente;
    },
    answerQuestion(resposta) {
      if (resposta === false && this.negativeAnswerBlockedByEvidence) {
        this.$notification.error(
          "Nao e possivel alterar para NAO uma pergunta que ja possui evidencia inserida."
        );
        return;
      }

      this.setLoading(true);
      this.perguntaObj.pergunta.resposta = resposta;
      attendanceQuestionAPI
        .update(this.perguntaObj.pergunta)
        .then((resp) => {
          this.loadQuestion();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    openThemePage() {
      this.$router.push("/diagnostico/" + this.acompanhamentoId + "/tema");
    },
    returnQuestion() {
      this.setLoading(true);
      if (this.perguntaObj.pergunta) {
        this.perguntaObj.percentual.perguntaAtual =
          this.perguntaObj.pergunta.perguntaId;
      } else {
        this.perguntaObj.percentual.perguntaAtual =
          this.perguntaObj.percentual.ultimaPerguntaRespondida;
      }

      this.perguntaObj.percentual.nacional =
        this.getMunicipioNaoVigenteRespondeSoPerguntasNacionais();
      diagnosticAPI
        .returnQuestion(this.perguntaObj.percentual)
        .then((resp) => {
          this.perguntaObj = resp.data;
          this.percentual = Math.ceil(
            (this.perguntaObj.percentual.perguntasRespondidas /
              this.perguntaObj.percentual.perguntasTema) *
              100
          );
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    finishTheme() {
      Swal.fire({
        title: "Deseja finalizar o diagnóstico?",
        text: `Essa ação não pode ser revertida.`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);

          diagnosticAPI
            .finishTheme(
              this.perguntaObj.percentual.acompanhamentoPercentualTemaId
            )
            .then((resp) => {
              this.$router.push(
                "/diagnostico/" + this.acompanhamentoId + "/tema"
              );
            })
            .catch((resp) => {
              this.setLoading(false);
              this.$notification.error("Erro ao finalizar pergunta");
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["loading", "isSala", "isFullAdmin"]),
    isAnswerTrue() {
      if (
        this.perguntaObj.pergunta.jaFoiRespondidaUmaVez &&
        this.perguntaObj.pergunta.ultimaResposta
      ) {
        return "warning";
      }
      return "accent";
    },
    isAnswerFalse() {
      if (this.negativeAnswerBlockedByEvidence) {
        return "grey";
      }

      if (
        this.perguntaObj.pergunta.jaFoiRespondidaUmaVez &&
        !this.perguntaObj.pergunta.ultimaResposta
      ) {
        return "error";
      }
      return "accent";
    },
    negativeAnswerBlockedByEvidence() {
      const pergunta = this.perguntaObj && this.perguntaObj.pergunta;

      return !!(
        pergunta &&
        (pergunta.evidenciada || pergunta.aprovada || pergunta.rejeitada)
      );
    },
  },
  async created() {
    this.setLoading(true);

    const { data: municipio } = await cityAPI.get(this.$route.params.id);
    this.municipio = municipio;
    this.setLoading(false);

    this.loadQuestion();
  },
  mounted() {
    document.getElementsByClassName("v-main__wrap")[0].style.background =
      'url("/assets/img/bg-diagnostico.jpg") no-repeat ';
    document.getElementsByClassName("v-main__wrap")[0].style.backgroundSize =
      "cover";
  },
  unmount() {
    document.getElementsByClassName("v-main__wrap")[0].style.background =
      "#fff";
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
